/* global axios */
import ApiClient from './ApiClient';

class PixPaymentsApi extends ApiClient {
  constructor() {
    super('pix_payments', { accountScoped: true });
  }

  create({ amountCents, description }) {
    return axios.post(this.url, {
      amount_cents: amountCents,
      description,
    });
  }
}

export default new PixPaymentsApi();
